<template>
  <div id="app">
    <div class="header">
      <div class="logo">
        <div>
          <img src="./assets/logo.png" />
        </div>
      </div>
      <div>
        <ul>
          <li v-for="(nav,path) in navArr" v-bind:key="path">
            <router-link :to="{path:nav.path}">{{nav.name}}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <router-view />
    <div class="footer">
      <div>COPYRIGHT©2019 北京师范大学儿童青少年积极发展研究课题组 版权所有</div>
      <div>
        <p>项目联系人：曹老师 电子邮件：PYD_China@126.com</p>
        <p>中科易研（北京）科技有限公司 提供技术服务</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      navArr: [
        { name: "网站首页", path: "/index" },
        { name: "项目介绍", path: "/ProjectIntroduction" },
        { name: "数据中心", path: "/DataCenter" },
        { name: "文档中心", path: "/DocumentCenter" },
        { name: "实践中心", path: "/PracticeCenter" },
        { name: "联系我们", path: "/ContactUs" }
      ]
    };
  }
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
  text-decoration: none;
  color: #333;
  list-style: none;
}
a {
  text-decoration: none;
}
</style>
<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.logo {
  background: #fce072;
}
.logo > div {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0;
}
.logo > div img{
  width: 902px;
  max-width: 100%;
}
.header > div > div {
  width: 80%;
  margin: auto;
}
.header > div > div > img {
  vertical-align: middle;
}

.header > div:nth-child(2) {
  background: #740015;
}
.header ul {
  width: 80%;
  margin: 0 auto;
}
.header ul li {
  display: inline-block;
  font-size: 24px;
}
.header ul li a {
  color: #fff;
  display: block;
  padding: 10px 20px;
}
.header ul li a.router-link-active{
  color: #740015;
  background: #fff
}
.footer {
  text-align: center;
  color: #fff;
}
.footer>div:first-child{
  background: #740015;
  color: #fff;
  line-height: 60px;
  font-size: 28px;
}
.footer>div:last-child{
  background: #fce072;
  padding: 20px 0
}
.footer  p {
  color: #740015;
  font-size: 28px;
  line-height: 40px;
}

@media screen and (max-width: 1600px) {
  .footer>div:first-child,
  .footer p{
    font-size: 22px;
  }
  .footer > div:last-child{
    padding: 10px 0;
  }
}
@media screen and (max-width: 1300px) {
  .header > div > div,
  .header ul{
    width: 90%;
    text-align: center;
  }
}
@media screen and (max-width: 1000px) {
  .header ul li{
    font-size: 20px;
  }
  .header ul li a{
    padding: 10px;
  }
  .footer>div:first-child,
  .footer p{
    font-size: 18px;
  }
  .footer>div{
    padding: 10px 0;
  }
  .footer>div:first-child,
  .footer p{
    line-height: 1.5;
  }
}
@media screen and (max-width: 768px) {
  .header ul{
    padding: 10px 0;
  }
  .header ul li a{
    padding: 0 10px;
    line-height: 30px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue